export default {
  pages: {
  },
  addPage(path, test) {
    dsf.unitTest.pages[path] = test;
  }
}